import React from 'react';
import { Link } from 'react-router-dom';
import { MdLogin, MdArrowForward } from 'react-icons/md';
import logo from '../assets/img/logo.webp';
import heroNetwork from '../assets/img/hero-network.png';

const Landing = () => {
  return (
    <div className="relative h-screen bg-white overflow-hidden flex flex-col">
      {/* Watermark Background */}
      <div className="pointer-events-none fixed inset-0 z-0 flex items-center justify-center opacity-20">
        <img src={logo} alt="Watermark" className="w-[70vw] max-w-[700px]" />
      </div>

      {/* Navigation */}
      <nav className="bg-white border-b border-gray-200 z-50 shadow-sm shrink-0">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4 flex justify-between items-center gap-4">
          <div className="flex items-center shrink-0">
            <Link to="/" className="flex items-center">
              <img src={logo} alt="RishtaForYou Logo" className="h-10 w-auto sm:h-12" />
            </Link>
          </div>
          <div className="flex gap-1.5 sm:gap-4 shrink-0">
            <Link
              to="/auth/sign-in"
              className="flex items-center gap-1 sm:gap-2 px-2.5 sm:px-5 py-1.5 sm:py-2 rounded-xl text-xs sm:text-base text-gray-700 font-semibold hover:bg-gray-50 transition-all duration-300 border border-gray-200"
            >
              <MdLogin />
              Login
            </Link>
            <Link
              to="/auth/sign-up"
              className="flex items-center gap-1 sm:gap-2 px-2 sm:px-6 py-1.5 sm:py-2 rounded-xl bg-blue-600 text-xs sm:text-base text-white font-semibold hover:bg-blue-700 transition-all duration-300 shadow-md"
            >
              Get Started
            </Link>
          </div>
        </div>
      </nav>

      {/* Hero Section — fills remaining screen height */}
      <section className="relative z-10 flex-1 flex items-center">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 w-full">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="max-w-2xl space-y-5 sm:space-y-7">
              {/* Badge */}
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-blue-50 border border-blue-100 rounded-full">
                <span className="w-2 h-2 rounded-full bg-blue-600 animate-pulse"></span>
                <span className="text-xs sm:text-sm text-gray-700 font-medium">India's Trusted Matrimonial & Referral Platform</span>
              </div>

              {/* Heading */}
              <h1 className="text-3xl sm:text-5xl lg:text-6xl font-extrabold leading-tight text-gray-900">
                Find Your Perfect Match
                <span className="block text-blue-600 mt-1 sm:mt-2">
                  & Earn While You Refer
                </span>
              </h1>

              {/* Subtext */}
              <p className="text-base sm:text-lg text-gray-600 leading-relaxed">
                Join thousands of happy couples and successful earners. Earn from your network up to 10 levels deep!
              </p>

              {/* Stats */}
              <div className="flex gap-8 sm:gap-12">
                <div>
                  <div className="text-2xl sm:text-3xl font-bold text-gray-900 mb-0.5">₹2000</div>
                  <div className="text-xs sm:text-sm text-gray-500">Membership Fee</div>
                </div>
                <div>
                  <div className="text-2xl sm:text-3xl font-bold text-gray-900 mb-0.5">10</div>
                  <div className="text-xs sm:text-sm text-gray-500">Levels Deep</div>
                </div>
                <div>
                  <div className="text-2xl sm:text-3xl font-bold text-gray-900 mb-0.5">2%</div>
                  <div className="text-xs sm:text-sm text-gray-500">Royalty Bonus</div>
                </div>
              </div>

              {/* CTA Buttons */}
              <div className="flex flex-col sm:flex-row gap-4">
                <Link
                  to="/auth/sign-up"
                  className="flex items-center justify-center gap-2 px-8 sm:px-10 py-3.5 rounded-2xl bg-blue-600 text-white font-bold text-base sm:text-lg hover:bg-blue-700 transition-all duration-300 shadow-md"
                >
                  Start Earning Now <MdArrowForward />
                </Link>
                <Link
                  to="/auth/sign-in"
                  className="flex items-center justify-center gap-2 px-8 sm:px-10 py-3.5 rounded-2xl border-2 border-gray-800 text-gray-800 font-bold text-base sm:text-lg hover:bg-gray-50 transition-all duration-300"
                >
                  Member Login
                </Link>
              </div>
            </div>

            {/* Right Side Image */}
            <div className="hidden lg:block relative">
              <div className="absolute -top-10 -left-10 w-72 h-72 bg-blue-50 rounded-full blur-3xl opacity-60"></div>
              <div className="absolute -bottom-10 -right-10 w-72 h-72 bg-indigo-50 rounded-full blur-3xl opacity-60"></div>
              <div className="relative z-10 w-full max-w-lg mx-auto overflow-hidden rounded-3xl shadow-2xl aspect-square border-4 border-white bg-slate-900 flex items-center justify-center">
                <img 
                  src={heroNetwork} 
                  alt="Matrimonial Network" 
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Landing;
